import { TApiUserSettingValue } from '@cbridge-packages/api';

/**
 * Parses a composite setting stored as a JSON string (the API accepts scalar values only).
 * A missing, non-string, corrupt or invalid value yields undefined so the caller keeps its defaults.
 */
export const parseJsonSetting = <T>(
  raw: TApiUserSettingValue | undefined,
  isValid: (value: unknown) => value is T,
): T | undefined => {
  if (typeof raw !== 'string' || !raw) {
    return undefined;
  }

  try {
    const parsed: unknown = JSON.parse(raw);

    return isValid(parsed) ? parsed : undefined;
  } catch {
    return undefined;
  }
};
